'use client';

import { useParams, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { LoadingState } from '~/app/(authorized)/_components/LoadingState';
import { ShopifyAppRoutes } from '~/constants/Routes';

const AuthorizedPage = () => {
  const params = useParams<{ workspaceId: string }>();
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const path = ShopifyAppRoutes.all(params.workspaceId);
    const search = searchParams.toString();

    router.replace(search ? `${path}?${search}` : path);
  }, [params.workspaceId, router, searchParams]);

  return <LoadingState />;
};

export default AuthorizedPage;
